export const PAGE_TITLE_STYLE = {
  fontSize: "30px",
  textAlign: "left",
  marginTop: "40px",
  marginLeft: "80px",
  color: "#000000",
};

export const COPYRIGHT_STYLE = {
  fontSize: "15px",
  textAlign: "center",
  color: "#000000",
  marginTop: "32px",
  marginBottom: "16px",
};

export const BODY_STYLE = {
  fontSize: "1.1em",
  lineHeight: 2,
};

export const SECTION_H2_STYLE = {
  color: "#0693e3",
  textAlign: "center",
};
